var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Collection from './Collection';
import Model from '../models/Model';
import { observable } from 'mobx';
/**
 *
 */
var PersistentCollection = /** @class */ (function (_super) {
    __extends(PersistentCollection, _super);
    /**
     * @param modelType Model
     * @param isPersistent boolean
     * @param storageName string
     */
    function PersistentCollection(modelType, isPersistent, storageName) {
        if (modelType === void 0) { modelType = Model; }
        if (isPersistent === void 0) { isPersistent = true; }
        if (storageName === void 0) { storageName = null; }
        var _this = _super.call(this, modelType) || this;
        _this.storageName = storageName ? storageName : _this.constructor.name;
        _this.isPersistent = isPersistent;
        // Delayed call so constructors can finish setting up Filters
        setTimeout(function () {
            _this.loadPersistentData();
        }, 1);
        return _this;
    }
    /**
     *
     */
    PersistentCollection.prototype.loadPersistentData = function () {
        var _this = this;
        if (this.isPersistent) {
            // List related
            var storedData = localStorage.getItem(this.storageName);
            if (storedData) {
                try {
                    this.addAll(JSON.parse(storedData));
                }
                catch (e) {
                    this.clearCache();
                }
            }
            // Filtered related
            var storedFilterData = localStorage.getItem(this.storageName + '-filters');
            if (storedFilterData) {
                try {
                    var filterMap = JSON.parse(storedFilterData);
                    filterMap.forEach(function (rule) {
                        _this.filter.getFilterByName(rule.name).value = rule.value;
                    });
                }
                catch (e) {
                    this.clearFilterCache();
                }
            }
            // Sort related
            var storedSortData = localStorage.getItem(this.storageName + '-sort');
            if (storedSortData) {
                try {
                    this.sort.update(JSON.parse(storedSortData));
                }
                catch (e) {
                    this.clearSortCache();
                }
            }
        }
    };
    /**
     *
     * @param array
     */
    PersistentCollection.prototype.addAll = function (array) {
        _super.prototype.addAll.call(this, array);
        this.updateCache(array);
        this.firstFetchComplete = true;
    };
    /**
     *
     * @param data
     */
    PersistentCollection.prototype.updateCache = function (data) {
        if (this.isPersistent) {
            try {
                localStorage.setItem(this.storageName, JSON.stringify(data));
            }
            catch (e) {
                console.log(e);
            }
        }
    };
    /**
     *
     */
    PersistentCollection.prototype.clearCache = function () {
        if (this.isPersistent) {
            try {
                localStorage.removeItem(this.storageName);
            }
            catch (e) {
                console.log(e);
            }
        }
    };
    /**
     *
     */
    PersistentCollection.prototype.updateFilterCache = function () {
        if (this.isPersistent) {
            try {
                var filterMap = this.filter.rules.map(function (rule) {
                    if (rule.name) {
                        return { name: rule.name, value: rule.value };
                    }
                    else {
                        return null;
                    }
                }).filter(function (object) {
                    return !!object;
                });
                localStorage.setItem(this.storageName + '-filters', JSON.stringify(filterMap));
            }
            catch (e) {
                console.log(e);
            }
        }
    };
    /**
     *
     */
    PersistentCollection.prototype.clearFilterCache = function () {
        if (this.isPersistent) {
            try {
                localStorage.removeItem(this.storageName + '-filters');
            }
            catch (e) {
                console.log(e);
            }
        }
    };
    /**
     *
     */
    PersistentCollection.prototype.updateSortCache = function () {
        if (this.isPersistent) {
            try {
                localStorage.setItem(this.storageName + '-sort', JSON.stringify(this.sort));
            }
            catch (e) {
                console.log(e);
            }
        }
    };
    /**
     *
     */
    PersistentCollection.prototype.clearSortCache = function () {
        if (this.isPersistent) {
            try {
                localStorage.removeItem(this.storageName + '-sort');
            }
            catch (e) {
                console.log(e);
            }
        }
    };
    __decorate([
        observable
    ], PersistentCollection.prototype, "firstFetchComplete", void 0);
    return PersistentCollection;
}(Collection));
export default PersistentCollection;
